import React, { useEffect, useMemo, useState } from 'react'
import { checkDirtyObjects, useForm } from './form'
import { Label } from './common/label'

export const FormSimpleVector3 = ({ name, label, required, hidden, readonly }) => {
  const { register, getOriginal, setValue, getFormSubmitting } = useForm(name, {
    required,
    valueAsObject: true,
    checkDirty: checkDirtyObjects,
    shouldDirty: true
  })

  const submitting = getFormSubmitting()

  const [x, updateX] = useState(0)
  const [y, updateY] = useState(0)
  const [z, updateZ] = useState(0)

  const handleChangeX = e => updateX(e.target.value)
  const handleChangeY = e => updateY(e.target.value)
  const handleChangeZ = e => updateZ(e.target.value)

  const original = getOriginal()

  useEffect(
    () => {
      if (original) {
        let obj = JSON.parse(original)
        updateX(obj.x)
        updateY(obj.y)
        updateZ(obj.z)
      }
    },
    [original]
  )

  useEffect(
    () => {
      let value = JSON.stringify({ x, y, z })
      setValue(value)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [x, y, z]
  )

  const className = useMemo(() => `form-control ${readonly && 'bg-secondary-subtle'}`, [readonly])

  return (
    <React.Fragment>
      <input type="hidden" {...register()} />

      <Label name={name} label={label} required={required} hidden={hidden}>
        <div className="input-group mb-2">
          <span className="input-group-text">X</span>
          <input className={className} type="number" step={0.1} value={x} disabled={submitting} onChange={handleChangeX} readOnly={readonly} />
        </div>
        <div className="input-group mb-2">
          <span className="input-group-text">Y</span>
          <input className={className} type="number" step={0.1} value={y} disabled={submitting} onChange={handleChangeY} readOnly={readonly} />
        </div>
        <div className="input-group mb-2">
          <span className="input-group-text">Z</span>
          <input className={className} type="number" step={0.1} value={z} disabled={submitting} onChange={handleChangeZ} readOnly={readonly} />
        </div>
      </Label>
    </React.Fragment>
  )
}
